import React, { useRef, useContext } from 'react'
import ScrollLock, { TouchScrollable } from 'react-scrolllock'

import { node, bool } from 'prop-types'

import { useOnClickOutside, useEscKeyPress, ModalContext } from '../../hooks'
import Icon from '../Icon'
import * as S from './styled'

const Modal = ({ children, centered }) => {
  const ref = useRef(null)

  const { modalState, setModalState } = useContext(ModalContext)

  useOnClickOutside(ref, () => setModalState(false))
  useEscKeyPress(() => setModalState(false))

  return (
    <>
      <ScrollLock isActive={modalState} />
      <S.ModalWrapper isOpen={modalState} ref={ref} className="overlay">
        <TouchScrollable>
          <S.ModalDialog centered={centered}>
            <S.ModalDialogContent>
              <S.ModalClose
                onClick={() => {
                  console.log('as')
                  setModalState(false)
                }}
                aria-label="close"
              >
                <Icon name="close" size={16} color="light" />
              </S.ModalClose>
              {children}
            </S.ModalDialogContent>
          </S.ModalDialog>
        </TouchScrollable>
      </S.ModalWrapper>
    </>
  )
}

Modal.defaultProps = {
  centered: true,
}

Modal.propTypes = {
  children: node,
  centered: bool,
}

export default Modal
